// Native
import Apex from 'react-apexcharts'

// Components
import {Flex, Spinner, useColorMode } from '@chakra-ui/react'

// Config
import { Moment, Mask } from 'config'

// Hooks
import { useReport } from 'hooks'

export default function WithdrawMonthlyGrowthChart({ period, ...props }){

    const { colorMode } = useColorMode()
    const report = useReport('withdraws_monthly_growth', period)

    const dates = report.data?.data?.map(item => item.date)
    const values = report.data?.data?.map(item => Mask.price(item.monthly_growth))

    const series = [
        {
            name: 'Pedidos de saque (R$)',
            data: values
        }
    ]

    const options = {
        theme: { 
            mode: colorMode,
            palette: 'palette5'
        },
        title: {
            text: 'Pedidos de saque por período (Mensal)',
            align: 'center'
        },
        subtitle: {
            text: `Com dados de ${Moment(report.data?.metadata?.starts).format('LL')} até ${Moment(report.data?.metadata?.ends).format('LL')} | Última atualização ${Moment(report.data?.metadata?.updated_at).calendar()}`,
            align: 'center'
        },
        chart: { 
            height: 350, 
            type: 'area', 
            background: 'transparent',
            locales: [require('apexcharts/dist/locales/pt.json')],
            defaultLocale: 'pt',
            zoom: { 
                enabled: true 
            }, 
            animations: { 
                enabled: true, 
                easing: 'easeinout', 
                animateGradually: {
                    enabled: true,
                    delay: 150 
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            } 
        },
        dataLabels: { 
            enabled: false 
        },
        stroke: { 
            curve: 'smooth'
        },
        grid: { 
            show: false 
        },
        xaxis: { 
            type: 'datetime', 
            categories: dates 
        },
        yaxis: {
            show: false
        },
        tooltip: { 
            x: { 
                format: 'MM/yy' 
            }, 
        }
    }

    // Loading state
    if(report.isLoading) return <Flex w="100%" h={350} alignItems="center" justifyContent="center"><Spinner /></Flex>

    // Chart
    return <Apex options={options} series={series} type="bar" height={350} />
}